const formatPhoneNumber = (
    phone?: {
        prefix?: string | number | null | undefined
        number?: string | number | null | undefined
    } | null | undefined
): string => {
    if (!phone?.number) return ''
    const number = String(phone.number)
    const prefix = phone.prefix == null ? '' : String(phone.prefix)
    const formattedNumber = number.replace(/(\d{3})(?=\d)/g, '$1 ').trim()
    const cleanPrefix = prefix.replace(/^\+/, '')
    return cleanPrefix ? `+${cleanPrefix} ${formattedNumber}` : formattedNumber
}

export default formatPhoneNumber
